export enum WORKER_ACTIONS {
  UPLOAD,
  UPLOAD_PROGRESS,
  FILE_UPLOADED,
  ERROR,
  REFRESH_TOKEN,
  SET_TOKEN
}
